export default __webpack_public_path__ + "static/media/wmv.f596ddc9.svg";